module.exports = __webpack_public_path__ + "img/about_1.1f26ec5a.jpg";